import React, { useEffect, useState } from "react";
import { useDispatch,useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { SelectedModule } from "../../components/SelectedModule/selected-module";
import Sidebar from "../../components/Sidebar/Sidebar";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TopBar } from "../../components/TopBar/TopBar";
import TabsComponent from "../../components/Tabs/tabs";
import { ModuleList } from "../../mock-data/Sidebar";
import "./VTrack.css";
import Cookies from 'universal-cookie';
import { getLocalStorageItem } from "../../common/utils/local-storage";
import { ACCESS_TOKEN } from "../../common/constants/local-storage-keys";
import { indexURL, VTrackURL } from "../../routes/routes";
import { Modules } from "../../common/constants/sidebar";
import moment from "moment";
import { DATE_TIME_FORMAT } from "../../common/constants/extra-constants";
import SessionFeedback from "../../components/Session/SessionFeedback";
import { setSessionFeedbackUrl } from "../../redux/actions";
import Loader from "../../components/Loaders/Loader";

export const VTrack = () => {
  const [headingName, setHeadingName] = useState("");
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const navigate = useNavigate();
  const [value, setValue] = useState(0);
  const cookies = new Cookies();
  const [tabIndex, setTabIndex] = useState(0);
  const [periodWeek, setPeriodWeek] = useState(null);
  const [sessionFeedbackId,setSessionFeedbackId]= useState(null);

  const { userData } = useSelector(({ USER }) => USER);
  const { vTrackLoader } = useSelector(({ APP_STATE }) => APP_STATE);
  const search = useLocation().search;
  const dispatch = useDispatch();
  useEffect(() => {
    const tabIndexQuery = new URLSearchParams(search).get('tabIndex');
    const id = new URLSearchParams(window.location.search).get('id');
    const periodWeekQuery = new URLSearchParams(search).get('periodWeek');
    if(id!==null){
      setSessionFeedbackId(id);
    }
    if(tabIndexQuery !== null && periodWeekQuery !== null){
      setTabIndex(parseInt(tabIndexQuery));
      setPeriodWeek({
        startDate:  moment(moment(periodWeekQuery.split("-")[0]).format(DATE_TIME_FORMAT)).startOf('isoweek'),
        endDate: moment(moment(periodWeekQuery.split("-")[1]).format(DATE_TIME_FORMAT)).endOf('isoweek')
      });
    }
    else{
      setTabIndex(0);
      setPeriodWeek(null);
    }
  }, []);

  const changePage = (headingName) => {
    setHeadingName(headingName);
    if(headingName === Modules.SESSION_FEEDBACK){
      setSessionFeedbackId(null);
    }
    setValue(0);
  };

  useEffect(()=>{
    const id = new URLSearchParams(window.location.search).get('id');
    if(id!==null){
      setSessionFeedbackId(id);
    }
    let routeName = window.location.pathname.split("/").at(-1);
    if(userData){
      let head = null;
      Object.keys(userData.data.tabs).forEach((ele) => {
        if(ele.toLowerCase() === routeName.toLowerCase()){
          head = ele;
        }
      })
      
      // Handle My Tasks which doesn't depend on user tabs
      if(routeName.toLowerCase() === 'mytasks'){
        setHeadingName("My Tasks");
      } else if(routeName.toLowerCase() === 'sowallocations'){
        setHeadingName("SOW Allocations");
      } else if(routeName.toLowerCase() === 'pointsdashboard'){
        setHeadingName(Modules.POINTS_DASHBOARD);
      } else if(routeName.toLowerCase() === 'veersapoints'){
        setHeadingName(Modules.VEERSA_POINTS);
      } else if(routeName.toLowerCase() === 'regularizeattendance'){
        setHeadingName(Modules.CORRECT_ATTENDANCE);
      } else if(routeName.toLowerCase() === 'allocationdashboard'){
        setHeadingName(Modules.RESOURCE_ALLOCATION);
      } else if (head !== null) {
        setHeadingName(ModuleList.find(e => e.key === head).name);
      } else {
        // Some modules (e.g. SOW for Admin) appear in the sidebar from essential keys but
        // may be absent from userData.data.tabs. Match the URL segment to ModuleList before
        // falling back to the arbitrary second tab (often projectAllocation).
        const routeLower = (routeName || "").toLowerCase();
        const fromModuleList = ModuleList.find(
          (m) => m.key.toLowerCase() === routeLower
        );
        if (fromModuleList) {
          setHeadingName(fromModuleList.name);
        } else {
          setHeadingName(
            ModuleList.find((e) => e.key === Object.keys(userData.data.tabs)[1]).name
          );
        }
      }
    }
  },[userData, navigate]);

  useEffect(() => {
    
    if(!getLocalStorageItem(ACCESS_TOKEN)){
      if(window.location.pathname === '/vTrack/SessionFeedback'){
        const urlParams = new URLSearchParams(window.location.search);
        const fullUrl = window.location.pathname + "?id=" + urlParams.get('id');
        dispatch(setSessionFeedbackUrl(fullUrl));
      }
      else if(window.location.pathname === '/vTrack/TrainingandSession')
        dispatch(setSessionFeedbackUrl(window.location.pathname));
      
      navigate(indexURL);
    }
  }, []);

  useEffect(() => {
    document.title = "vTrack";
  }, []);

  const toggleSidebar = () => {
    setSidebarVisible(!sidebarVisible);
  };

  return (
    <>
      {vTrackLoader && <Loader />}
      <div className={`mainDiv ${sidebarVisible ? "sidebar-open" : ""}`}>
      {/* <TopBar headingName={headingName} toggleSidebar={toggleSidebar} /> */}
      {sidebarVisible && <div className="overlay" onClick={toggleSidebar}></div>}
        <div className={`sidebarContainer ${sidebarVisible ? "visible" : ""}`}>
          <Sidebar changePage={changePage} />
        </div>
        <button className="toggleButton" onClick={toggleSidebar}>
            ☰
          </button>
        <div className="rightContainer">
        
          <div className="selectedModule">
            <SelectedModule headingName={headingName} value={value} setValue={setValue} tabIndex={tabIndex} periodWeek={periodWeek} setTabIndex={setTabIndex} setPeriodWeek={setPeriodWeek} feedbackId={sessionFeedbackId} />
          </div>
        </div>

      </div>
    </>
  );
};
